// extracted by mini-css-extract-plugin
module.exports = {"sideDrawerListItem":"SideDrawerListItem_sideDrawerListItem__jYkHt"};